import React from "react";
import "./LinearGradientSVG-style.css"

export const LinearGradientSVG = props => {
  return (
    <div className="linear-gradient-svg"></div>
  );
};